import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import BookingHistory from '@/components/dashboard/BookingHistory';

const Meetings = () => {
  return (
    <DashboardLayout>
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold">Meetings</h1>
        <p className="text-muted-foreground mt-1">
          View and manage all your scheduled meetings
        </p>

        <Tabs defaultValue="upcoming" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="upcoming">Upcoming</TabsTrigger>
            <TabsTrigger value="past">Past</TabsTrigger>
            <TabsTrigger value="canceled">Canceled</TabsTrigger>
          </TabsList>
          <TabsContent value="upcoming">
            <Card>
              <CardHeader>
                <CardTitle>Upcoming Meetings</CardTitle>
                <CardDescription>
                  View all your scheduled meetings that are coming up.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <BookingHistory />
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="past">
            <Card>
              <CardHeader>
                <CardTitle>Past Meetings</CardTitle>
                <CardDescription>
                  View your previous meetings.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="p-4 text-center text-muted-foreground">
                  No past meetings found.
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="canceled">
            <Card>
              <CardHeader>
                <CardTitle>Canceled Meetings</CardTitle>
                <CardDescription>
                  View meetings that have been canceled.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="p-4 text-center text-muted-foreground">
                  No canceled meetings found.
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};

export default Meetings;
